<script lang="ts" setup>
/* Types */
import { SetTimePayload } from '@/store/basket/basket.types'

/* Stores */
import { useBasketStore } from '@/store/basket/basket'
import { useBasketTimeStore } from '@/store/basket/basket-time'
import { useBasketPaymentMethodsStore } from '@/store/basket/basket-payment-methods'

/* Components */
import BasketTitle from '@/components/Basket/basket-utils/BasketTitle.vue'
import BasketTimeInfo from '@/components/Basket/basket-time/BasketTimeInfo.vue'
import BasketTimeTabs from '@/components/Basket/basket-time/BasketTimeTabs.vue'
import BasketTimeTabActive from '@/components/Basket/basket-time/BasketTimeTabActive.vue'

/* Types */
import { TabTypes } from '@/types/components/basket-time.types'

type Props = {
  triggeredAviableTime: boolean
}
const props = defineProps<Props>()

const basketStore = useBasketStore()
const basketTimeStore = useBasketTimeStore()
const { getPaymentMethods } = useBasketPaymentMethodsStore()

onMounted(() => {
  // Фетчим данные для "Как можно скорее"
  updateTime({ delivery_at_client: false })
})

const selectedTab = ref<TabTypes>(TabTypes.FAST)

// Обновляем данные, когда изменился адрес
watch(
  () => props.triggeredAviableTime,
  () => {
    if (selectedTab.value !== TabTypes.FAST) {
      return
    }

    updateTime({ delivery_at_client: false })
  },
)

watch(
  () => selectedTab.value,
  (tabValue) => {
    if (tabValue === TabTypes.FAST) {
      updateTime({ delivery_at_client: false })
    }
  },
)

const updateTime = async (data: SetTimePayload) => {
  await basketTimeStore.getAvailableTime(data)

  await basketStore.setTime({
    delivery_at: basketTimeStore.delivery_at,
    delivery_at_client: data.delivery_at_client,
  })

  await getPaymentMethods()
}

const isLoading = computed(
  () =>
    !basketTimeStore.delivery_at &&
    !basketTimeStore.error &&
    basketTimeStore.variants.length === 0,
)
</script>

<template>
  <section id="delivery_at" class="basket-time">
    <basket-title title="Время" />

    <basket-time-tabs v-model="selectedTab" class="basket-time__tabs" />

    <basket-time-tab-active
      :selected-tab="selectedTab"
      :error-message="basketTimeStore.error"
      :warning-message="basketTimeStore.warning"
      :warning-icon="basketTimeStore.warning_icon"
      :triggered-aviable-time="triggeredAviableTime"
      @update-time="updateTime"
    />

    <app-progress v-if="isLoading" class="basket-time__loader" />

    <transition v-else-if="basketTimeStore.delivery_at" name="height">
      <basket-time-info />
    </transition>
  </section>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/animations.scss';

.basket-time__tabs {
  margin-bottom: 30px;
}

.basket-time__loader {
  height: max-content;
}

.tab-fade-transition-enter {
  opacity: 0;
  transition: all 0.15s ease-in-out;
}
.tab-fade-transition-enter-to {
  opacity: 1;
  transition: all 0.15s ease-in-out;
}
.tab-fade-transition-leave {
  position: absolute !important;
  top: 0;
  width: 100%;
  opacity: 1;
  transition: all 0.15s ease-in-out;
}
.tab-fade-transition-leave-to {
  position: absolute !important;
  top: 0;
  width: 100%;
  opacity: 0;
  transition: all 0.15s ease-in-out;
}
</style>
